import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActiveContact = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 18,
			stroke: "#BCA4FF",
			strokeDasharray: "7 7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 14,
			fill: "#8E68F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.6454 23.2202C25.6454 23.4602 25.592 23.7068 25.4787 23.9468C25.3654 24.1868 25.2187 24.4135 25.0254 24.6268C24.6987 24.9868 24.3387 25.2468 23.932 25.4135C23.532 25.5802 23.0987 25.6668 22.632 25.6668C21.952 25.6668 21.2254 25.5068 20.4587 25.1802C19.692 24.8535 18.9254 24.4135 18.1654 23.8602C17.3987 23.3002 16.672 22.6802 15.9787 21.9935C15.292 21.3002 14.672 20.5735 14.1187 19.8135C13.572 19.0535 13.132 18.2935 12.812 17.5402C12.492 16.7802 12.332 16.0535 12.332 15.3602C12.332 14.9068 12.412 14.4735 12.572 14.0735C12.732 13.6668 12.9854 13.2935 13.3387 12.9602C13.7654 12.5402 14.232 12.3335 14.7254 12.3335C14.912 12.3335 15.0987 12.3735 15.2654 12.4535C15.4387 12.5335 15.592 12.6535 15.712 12.8268L17.2587 15.0068C17.3787 15.1735 17.4654 15.3268 17.5254 15.4735C17.5854 15.6135 17.6187 15.7535 17.6187 15.8802C17.6187 16.0402 17.572 16.2002 17.4787 16.3535C17.392 16.5068 17.2654 16.6668 17.1054 16.8268L16.5987 17.3535C16.5254 17.4268 16.492 17.5135 16.492 17.6202C16.492 17.6735 16.4987 17.7202 16.512 17.7735C16.532 17.8268 16.552 17.8668 16.5654 17.9068C16.6854 18.1268 16.892 18.4135 17.1854 18.7602C17.4854 19.1068 17.8054 19.4602 18.152 19.8135C18.512 20.1668 18.8587 20.4935 19.212 20.7935C19.5587 21.0868 19.8454 21.2868 20.072 21.4068C20.1054 21.4202 20.1454 21.4402 20.192 21.4602C20.2454 21.4802 20.2987 21.4868 20.3587 21.4868C20.472 21.4868 20.5587 21.4468 20.632 21.3735L21.1387 20.8735C21.3054 20.7068 21.4654 20.5802 21.6187 20.5002C21.772 20.4068 21.9254 20.3602 22.092 20.3602C22.2187 20.3602 22.352 20.3868 22.4987 20.4468C22.6454 20.5068 22.7987 20.5935 22.9654 20.7068L25.172 22.2735C25.3454 22.3935 25.4654 22.5335 25.5387 22.7002C25.6054 22.8668 25.6454 23.0335 25.6454 23.2202Z",
			stroke: "white",
			strokeMiterlimit: 10
		})
	]
});
export default SvgActiveContact;
